<template>
    <v-app>
      
        <v-app-bar app clipped-left v-if="currentRouteName!='login'" dark dense flat class="primary fixNotchPaddingTop">

            <v-toolbar-items class="wedrive-toolbar-title">
                <img v-if="!navTitle" src='img/logo-wedrive-blanco.svg' style="margin-top: 10px; margin-left: -15px; width: 160px"/>
                <span @click="$router.go(-1)" v-if="navTitle" style="padding-top: 12px; cursor: pointer;">
                    <v-icon style="position: relative; top: -2px; margin-right: 2px;">mdi-arrow-left</v-icon>
                    {{this.navTitle}}
                </span>
            </v-toolbar-items>

            <v-spacer></v-spacer>

            <!--<span class="light--text wedrive-username-header">{{ username }}</span>-->

            <v-icon v-if="numAttempts >= 2" style="top: -1px; margin-right: 5px; font-size: 13px;">mdi-alert</v-icon>
            <span style="color:#E1E1E1; font-size:0.75em; font-weight: 500; white-space: nowrap;">
                {{ $t('app.last-update') }}: {{ $store.state.wedrive.lastUpdate ? formatLocalTime($store.state.wedrive.lastUpdate) : '' }}
            </span>

            <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    class="light--text"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    >
                    <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item @click="logout()">
                    <v-list-item-title>{{ $t('app.logout') }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            
        </v-app-bar>

        <!-- Sizes your content based upon application components -->
        <v-main v-if="!isLoading">
            <v-container fluid class="wedrive-main-container fixNotchPaddingBottom" style="background-color: #E3E3E3; height: 100vh; overflow: hidden;">        
            <!--     <v-row v-if="showLastUpdate" class="wedrive-last-update-container">
                    <v-col cols="12" class="mx-auto" style="margin: 0; color: #FFF; text-align: center;">
                        <v-icon color="white" style="top: -3px; margin-right: 5px;">mdi-update</v-icon>
                        <span>{{ $t('app.last-update') }}: {{ $store.state.wedrive.lastUpdate ? formatLocalTime($store.state.wedrive.lastUpdate) : '' }}</span>
                    </v-col>
                </v-row> -->

                <keep-alive>
                    <transition :name="transitionName">                
                        <router-view></router-view>            
                    </transition>
                </keep-alive>  
            </v-container>
        </v-main>

        <!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
        <v-snackbar
            v-model="showAlert"
            :timeout="alertTimeout"
            :color="alertColor">
                {{ alertText }}
                <v-btn text @click="showAlert=false">
									{{ $t('app.buttons.close') }}
                </v-btn>
        </v-snackbar>
        <!-- FIN BLOQUE ESTADO PETICIONES -->

    </v-app>
</template>

<script>
import BaseModule from './components/common/BaseModule'
import cordova from "./api/cordova"; 

export default {
    name: 'App',
    mixins: [ BaseModule ],
    components: {},
    data () {
        return {
            intervalId: null,
            transitionName: 'slide-left',
            isLoading: false,
            showAlert: false,
            alertColor: 'error',
            alertText: '',
            alertTimeout: 3000,
        }
    },
    computed: {
        accessError() {
            return !this.$store.state.wedrive.token || !this.$store.state.wedrive.user;// || !this.$store.state.wedrive.user.userName;
        },
        username() {
            return this.$store.state.wedrive.user && this.$store.state.wedrive.user.userName ? this.$store.state.wedrive.user.userName[0] : '';
        },
        navTitle() {
            return this.$store.state.wedrive.navTitle;
        },
        showLastUpdate() {
            return this.$store.state.wedrive.showLastUpdate;
        },
        numAttempts() {
            return this.$store.state.wedrive.numAttempts;
        },
        currentRouteName() {
            return this.$route.name;
        }
    },
    mounted: function () {
        this.doRefreshEveryMinute();
        cordova.init();
    },
    beforeDestroy: function () {
       clearInterval(this.intervalId);
    },
    methods: {
        logout: function() {
            this.$store.commit('wedrive/setToken', null);
            this.$router.push({ name: 'login' });
        },
        doRefreshEveryMinute: function() {  
            var me = this;

            this.intervalId = setInterval(function() {              
                if (!me.$store.state.wedrive.token) return; 

                me.updateMobileData();
            }, 60 * 1000);
        }
    },
    watch: {
        '$route' (to, from) {
            const toDepth = to.path.split('/').length
            const fromDepth = from.path.split('/').length
            this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
        }
    }
};
</script>

<style scoped>
.app-main {
    background: #f1f4f6;
}    
</style>